<template>
    <div>
        <!-- Title and Logo -->
        <HeaderCard />
        <!-- end Logo and Title -->

        <!-- Panel Start here -->
        <panel title="Laporan Surat Tanda Setoran" class="panel panel-dark">
            <div class="my-0">
                <form>
                    <b-card>
                        <div class="">
                            <h5>MASUKKAN PERIODE</h5>
                            <div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-2 col-form-label font-weight-bold"
                                        >Badan Usaha
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <v-select
                                                    label="nama"
                                                    :reduce="nama => nama.id"
                                                    :options="Npbu.npbu"
                                                    placeholder="-Pilih Badan Usaha-"
                                                    v-model="pencarian.npbu_id"
                                                    :disabled="role.includes('Badan Usaha')"
                                                >
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-2 col-form-label font-weight-bold"
                                        >Tahun
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <v-select
                                                    :options="helper.tahunBerjalan"
                                                    v-model="pencarian.tahun"
                                                    placeholder="-Pilih-"
                                                >
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-2 col-form-label font-weight-bold"
                                        >Status Bayar
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <v-select
                                                    label="nama"
                                                    :reduce="nama => nama.id"
                                                    :options="helper.status"
                                                    placeholder="-Pilih-"
                                                    v-model="pencarian.lunas"
                                                >
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                    <b-card class="">
                        <b-row>
                            <b-col>
                                <b-button variant="primary" @click="showPdf">
                                    <i class="fa fa-eye"></i> Lihat
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </form>
            </div>
        </panel>
        <!-- Selesai button loader -->
        <b-modal
            v-model="helper.showLoader"
            id="modalLoader"
            hide-footer
            hide-header
            no-close-on-backdrop
            centered
            size="sm"
        >
            <div class="text-center text-primary">
                <b-spinner
                    variant="primary"
                    label="Text Centered"
                ></b-spinner>
                <h5>Harap Menunggu...</h5>
                <div>Data Anda Sedang Di Proses</div>
            </div>
        </b-modal>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import HeaderCard from "@/components/header/HeaderCard.vue";
import axios from "axios";
import deleteMixins from "@/helper/delete_api";
import cekAuthMixins from "@/helper/cek401";
import resetMixins from "@/helper/resetForm";
import { mapState } from "vuex";
import jabatanMixin from "@/helper/jabatan/jabatan";

export default {
    mixins: [deleteMixins, cekAuthMixins, resetMixins, jabatanMixin],
    components: {
        HeaderCard
    },
    data() {
        return {
            // helper variable
            helper: {
                perangkat: "",
                errors: "",
                jabatan: "",
                tahunBerjalan: [],
                status: [
                    {
                        id: 'all',
                        nama: 'Semua Status'
                    },
                    {
                        id: 1,
                        nama: 'Sudah Setor'
                    },
                    {
                        id: 0,
                        nama: 'Belum Setor'
                    }
                ],
                showLoader: false,
                pdfUrl: ''
            },
            pencarian: {
                npbu_id: '',
                tahun: '',
                lunas: ''
            },
            user: JSON.parse(localStorage.getItem('user')),
            role: JSON.parse(localStorage.getItem('roleArr'))
        };
    },
    computed: {
        fieldOptions() {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        },
        // unit store variable
        ...mapState(["Npbu"])
    },
    mounted() {
        // call unit option api (vuex)
        this.$store.dispatch("Npbu/getNpbu");
        if (this.user.npbu_id) {
            this.pencarian.npbu_id = this.user.npbu_id
            const now = new Date()
            const tahun = now.getFullYear()
            this.pencarian.tahun = tahun
            this.pencarian.lunas = 'all'
        } else {
            const now = new Date()
            const tahun = now.getFullYear()
            this.pencarian.tahun = tahun
            this.pencarian.lunas = 'all'
        }
        this.tahunBuku()
    },
    methods: {
        // get 3 tahun buku
        tahunBuku() {
            const now = new Date();
            let tahun = now.getFullYear();
            for (let jumlahTahun = 2; jumlahTahun >= 0; jumlahTahun--) {
                this.helper.tahunBerjalan.push(tahun - jumlahTahun);
            }
        },
        // get pdf
        async showPdf () {
            try {
                this.helper.showLoader = true
                let response = await axios.get('/api/laporan/transaksi/ssr',{
                    params: this.pencarian,
                    responseType: "arraybuffer"
                })
                if (response.data) {
                    this.helper.showLoader = false
                    this.helper.pdfUrl = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }))
                    window.open(this.helper.pdfUrl, "_blank")
                }
            } catch (error) {
                this.helper.showLoader = false
                // console.log(error)
                if (error.response.status == 401) {
                    // mixins - cek auth
                    this.cekAuth()
                }
            }
        }
    }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    border-color: red;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
</style>
